import { message } from "antd";
import { GET, POST, PUT } from "../../../services/api";
import { ApiUrl } from "../../../ApiHelper/ApiUrl";
import { clientTypes } from "../../type/clientTypes";
import { toast } from "react-toastify";
import { cleanObject } from "../../../utils/commonFunctions";

export const getPodcastData = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: clientTypes.GET_PODCAST_DATA_PENDING,
        isLoading: true,
      });
      const cleanedPayload = cleanObject(payload);
      const res = await GET(
        `${ApiUrl.CLIENT_PODCAST_DATA_GET}`,
        cleanedPayload
      );
      dispatch({
        type: clientTypes.GET_PODCAST_DATA_SUCCESS,
        payload: res.data?.result ?? [],
        isLoading: false,
        msg: res.data.message ?? "",
      });
    } catch (error) {
      dispatch({
        type: clientTypes.GET_PODCAST_DATA_FAILED,
        payload: [],
        isLoading: false,
        msg: (error && error?.message) ?? "",
      });
    }
  };
};

export const getPodcastDetailsData = (index) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: clientTypes.GET_PODCAST_DETAILS_DATA_PENDING,
        isLoading: true,
      });
      const id = `podcast_id=${index}`;
      const res = await GET(`${ApiUrl.CLIENT_PODCAST_DETAILS_DATA_GET}/?${id}`);
      dispatch({
        type: clientTypes.GET_PODCAST_DETAILS_DATA_SUCCESS,
        payload: res.data?.result ?? [],
        isLoading: false,
        msg: res.data.message ?? "",
      });
    } catch (error) {
      dispatch({
        type: clientTypes.GET_PODCAST_DETAILS_DATA_FAILED,
        payload: [],
        isLoading: false,
        msg: (error && error?.message) ?? "",
      });
    }
  };
};
